import { Outlet } from 'react-router-dom';
import { OnboardTemplate } from '@/Templates/Onboard/Onboard.template';

/**
 * Onboard Layout
 * Wraps the signed-out pages (login, and later password recovery) with OnboardTemplate.
 */
const OnboardLayout = () => (
  <OnboardTemplate>
    <Outlet />
  </OnboardTemplate>
);

export { OnboardLayout };
